export class StoryLink {
  public title: string;
  public url: string;

  constructor(data: Partial<StoryLink> = {}) {
    this.title = data?.title ?? '';
    this.url = data?.url ?? '';
  }

  public static createFromApi(data: Partial<StoryLink> = {}): StoryLink {
    return new StoryLink(data);
  }

  public processForApi(): Record<string, any> {
    return {
      title: this.title,
      url: this.url,
    };
  }
}
